import axios from "axios";
import { API_URL } from "./../../utils/api-utils";
import  {common}  from "./../../utils";


export const GetListFAQ = async (param)=>{
    let url =  `${API_URL.Lobby}/api/Faq/GetListFAQ`;
    let result  = await axios.post(url, param);
    console.log(result);
    if (result && result.data) return result.data; 
}
